import axiosConfig from '../utils/axiosConfigInstance';

export const loginApi = async (email, password) => {
	return await axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/login`, { email, password });
};

export const StudioSignupApi = async formData => {
	return await axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/studio/signup`, formData);
};

export const deleteUserChangeApi = async (id, password) => {
	return await axiosConfig.delete(`${import.meta.env.VITE_APP_API_URL}/user/change/delete/${id}`, {
		data: { password }
	});
};

export const authApis = {
	loginApi
};
